import { render, staticRenderFns } from "./IdleStatus.vue?vue&type=template&id=3f235819&scoped=true&"
import script from "./IdleStatus.vue?vue&type=script&lang=js&"
export * from "./IdleStatus.vue?vue&type=script&lang=js&"
import style0 from "./IdleStatus.vue?vue&type=style&index=0&id=3f235819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f235819",
  null
  
)

export default component.exports